<template>
  <div>
    <!-- Header Included here -->
    <Header />

    <!-- Slider Included here -->
    <Slider />

    <!-- Marketplace Included here -->
    <MarketPlace
      title="The best graded produce available at scale from local farmers."
    />
    <MarketPlace
      :isSecond="true"
      title="The best processed and semi-processed raw materials available at scale."
    />
    <MarketData isComponent="{true}" />
    <Footer />
    <!-- Live Market Price Included here -->
    <market-price />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Slider from "@/components/Slider.vue";
import Footer from "@/components/Footer.vue";
import MarketPrice from "@/components/MarketPrice.vue";
import MarketPlace from "@/components/MarketPlace.vue";
import MarketData from "@/components/MarketData";

export default {
  name: "home",
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Home",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    Header,
    Slider,
    MarketPrice,
    MarketPlace,
    MarketData,
    Footer
  }
};
</script>
